'use client'

let hasSelectedPosInCurrentSession = false

export function getHasSelectedPosInCurrentSession() {
  return hasSelectedPosInCurrentSession
}

export function markPosAsSelectedLocally() {
  hasSelectedPosInCurrentSession = true
}

export function clearPosSelectedLocally() {
  hasSelectedPosInCurrentSession = false
}
